// extracted by mini-css-extract-plugin
export default {"stockStatus":"ProductDetailInStock_stockStatus__5+8F4"};